import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SprogLag, SprogLagLanguageMap } from '../translations.model';
import { TranslationsService } from '../translations.service';
import { ModalService } from 'src/app/services/modal.service';
import { ErrorService } from 'src/app/common/errors/error.service';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-translations-field',
    templateUrl: './translations-field.component.html',
    styleUrls: ['../translations.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, FormsModule]
})
export class TranslationsFieldComponent {
  @Input({ required: true }) translationContext!: SprogLagLanguageMap;
  @Input({ required: true }) sprogLag!: SprogLag;
  @Input({ required: true }) isEdited!: boolean;
  @Input({ required: true }) tabIndex!: number;
  @Input({ required: true }) cultureIds: string[] = [];
  @Input({ required: true }) cultureId!: string;
  @Input({ required: true }) readOnly!: boolean;

  @Output() markEdited = new EventEmitter<void>();
  @Output() translateEmptyFields = new EventEmitter<void>();

  constructor(
    private translationsService: TranslationsService,
    private modalService: ModalService,
    private errorService: ErrorService
  ) {
  }

  handleChange(event: Event): void {
    this.markEdited.emit();
    this.sprogLag.isEdited = true;
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.altKey && event.key === 'a') {
      event.preventDefault();
      this.suggestTranslation(event);
    }
  }

  async suggestTranslation(event: Event): Promise<void> {
    const isBlank = this.sprogLag.vaerdi.trim() === '';
    event.preventDefault();

    let textToTranslate = '';
    let sourceLanguage = '';
    // Iterate from left to right until a text is found, then use that as the base for translation
    for (const cultureId of this.cultureIds) {
      const text = this.translationContext.languageMap[cultureId]?.vaerdi;
      if (text) {
        textToTranslate = text;
        sourceLanguage = cultureId.substring(0, 2); // Extract the first 2 characters
        break;
      }
    }

    if (!textToTranslate) {
      console.log('No text found to translate.');
      return;
    }

    const targetLanguage = this.sprogLag.cultureId.substring(0, 2); // Extract the first 2 characters

    console.log("Translating text:", textToTranslate, "to language:", targetLanguage);

    try {
      const translatedText = await this.translationsService.translateText(textToTranslate, sourceLanguage, targetLanguage);
      if (isBlank) {
        console.log('Translated Text:', translatedText);
        this.sprogLag.vaerdi = translatedText;
      } else {
        const result = await this.modalService.showAiTranslationModal(this.sprogLag, translatedText);
        if (result === '') return;
        this.sprogLag.vaerdi = result;
      }
      this.translationContext.isEdited = true;
      this.sprogLag.isEdited = true;
    } catch (error: any) {
      this.errorService.notify(error?.message ?? String(error), { title: 'Fejl ved oversættelse' });
    } finally {
      console.log('Translation complete.');
    }
  }

  async expandText(event: Event): Promise<void> {
    event.preventDefault();
    const result = await this.modalService.showTranslationExtendedTextModal(this.sprogLag.vaerdi, this.sprogLag.cultureId);
    if (result) {
      this.sprogLag.vaerdi = result;
      this.sprogLag.isEdited = true;
      this.translationContext.isEdited = true;
    }
  }

  translateAll(event: Event): void {
    event.preventDefault();
    this.translateEmptyFields.emit();
  }
}
